import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { BookingsShellComponent } from './bookings-shell.component';
import { BookingsNavigationComponent } from '@rx-applications/clientsite/bookings/ui';

@NgModule({
  declarations: [
    BookingsShellComponent
  ],
  imports: [
      CommonModule,
      RouterModule,
      BookingsNavigationComponent
  ],
})
export class BookingsShellModule {}
